import { AccountMovementsViewModel } from "../../../accounting/models/accounting-movement.model";

export class ReserveModel {
    uid: number;
    amount: number;
    reserveTypeId: number;
    reserveTypeName: string;
    manualMovement: AccountMovementsViewModel;
    accountingModelsId: number;
    accountingModelsNumber: string;
}

export class ReserveTypeModel {
    id: number;
    name: string;
}